import { encryptStorage } from "../../../../constants/EncryptStorage";
import { ApiDashboard } from "../api/ApiReport";


export const dashboardAirlineLuggageCount = async () => {
  try {
    const role = encryptStorage.getItem("role");
    const userId = encryptStorage.getItem("userId");

    // Prepare request model only if needed
    const model = {};

    if (role === "Carrier" && userId) {
      model.carrierId = userId;
    }

    // Make API call
    const response = await ApiDashboard().getAirlinesLuggageCount(model);

    // Simplify naming: response instead of "data"
    if (response?.success) {
      return { success: true, data: response.response };
    } else {
      // Return standardized error info
      return {
        success: false,
        data: response?.errors || "Unknown error occurred",
      };
    }
  } catch (error) {
    console.error("Error fetching dashboard airline luggage count:", error);

    return {
      success: false,
      data: error?.message || "Network or server error occurred",
    };
  }
};
